import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReviewComponent } from './components/review/review.component';

const routes: Routes = [
  {
    path: 'form/:sampletype/:id',
    component: ReviewComponent,
  },
  {
    path: 'form/:sampletype',
    component: ReviewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReviewRoutingModule { }
